(function(angular){
    'use strict';
    class SearchTutorialController {
        constructor(CoreUserService, ICMUserService, translationService, $translate, $location, $rootScope) {
            this.CoreUserService = CoreUserService;
            this.ICMUserService = ICMUserService;
            this.$translate = $translate;
            this.$location = $location;
            this.$rootScope = $rootScope;
            this.renderTutorial = false;
            this.isSearchRoute = false;

            this.$rootScope.$on('$locationChangeSuccess', () =>{
                if(this.$location.path() === '/influencers/search') {
                    this.isSearchRoute = true;

                    this.CoreUserService.getCurrent(true).then((currentUser)=>{
                        this.ICMUserService.getAppSettings('contacts', currentUser._id).then((contactSettings) => {
                            let showTutorial = true;
                            if(contactSettings && contactSettings.showSearchTutorial === false) {
                                showTutorial = false;
                            }
                            if (showTutorial === true) {
                                translationService.waitForTranslations().then(()=>{
                                    this.renderTutorial = true;
                                    contactSettings.showSearchTutorial = false;
                                    this.ICMUserService.setAppSettings('contacts', contactSettings);

                                    this.steps[0].description = this.$translate.instant('icm-search__tutorial--step-one');
                                    this.steps[1].description = this.$translate.instant('icm-search__tutorial--step-two');
                                    this.steps[2].description = this.$translate.instant('icm-search__tutorial--step-three');
                                });
                            }
                        });
                    });
                }
            });

            this.steps = [
                {
                    imagePosition: '0px',
                    description: 'Welcome to the new Influencers Search. You can enter multiple terms into the search bar. Use a comma or the tab key to create phrases and add additional words.',
                    descriptionCss: {
                        'background-color': '#B42E9E'
                    }
                },
                {
                    imagePosition: '1300px',
                    description: 'You can use the filters on the left to refine your search and find more relevant results.',
                    descriptionCss: {
                        'background-color': '#FF6622;'
                    }
                },
                {
                     imagePosition: '650px',
                     description: 'You can switch between Contacts and Sources searches by clicking on the link for the current setting.',
                     descriptionCss: {
                         'background-color': '#50BB99'
                     }
                }
            ];

            this.currentStep = this.steps[0];
            this.currentStepIndex = 0;
            this.setImagePosition(this.currentStep.imagePosition);
        }

        isLastStep(){
            return this.currentStep === this.steps[this.steps.length-1];
        }

        toNextStep(){
            this.currentStepIndex += 1;
            this.currentStep = this.steps[this.currentStepIndex];
            this.setImagePosition(this.currentStep.imagePosition);
        }

        toPreviousStep(){
            this.currentStepIndex -= 1;
            this.currentStep = this.steps[this.currentStepIndex];
            this.setImagePosition(this.currentStep.imagePosition);

        }

        setImagePosition(imagePosition){
            $('.search-tutorial-picture').css('background-position-x', imagePosition);
        }

        hideTutorial() {
            this.renderTutorial = false;
        }
    }

    angular.module('MW.ContactManager.SearchTutorial', [
        'MW.Framework.CoreUserService', 
        'MW.Framework.ICMUserService',
        'MW.Framework.TranslationService'])
    .component('searchTutorial', {
        bindings: {
        },
        controller: ['CoreUserService', 'ICMUserService', 'translationService', '$translate', '$location', '$rootScope', SearchTutorialController],
        template: `
            <div class="search-tutorial-wrapper" ng-show="$ctrl.isSearchRoute && $ctrl.renderTutorial" ng-cloak>
                <div class="search-tutorial-modal-container" layout="column" layout-align="space-around center">
                    <div class="top-container" layout="row" layout-align="center center">
                        <md-button class="mw-fab md-fab" ng-if="$ctrl.currentStepIndex !== 0" aria-label="Previous" ng-click="$ctrl.toPreviousStep()">
                            <md-icon md-svg-icon="navigation:ic_arrow_back_24px"></md-icon>
                        </md-button>
                        <div class="left-placeholder" ng-if="$ctrl.currentStepIndex === 0"></div>
                        <md-card ng-style="$ctrl.currentStep.descriptionCss">
                            <div class="search-tutorial-picture" style="background-image: url('https://assets.meltwater.io/icm-web-assets/static/img/search_tutorial/all_steps.png')"></div>
                            <div class="search-tutorial-text" layout="column" layout-align="center center">
                                <span class="text-wrap">{{$ctrl.currentStep.description}}</span>
                            </div>
                        </md-card>

                        <md-button class="mw-fab md-fab" ng-show="!$ctrl.isLastStep()" ng-click="$ctrl.toNextStep()" aria-label="Next">
                            <md-icon md-svg-icon="navigation:ic_arrow_forward_24px"></md-icon>
                        </md-button>

                        <md-button class="mw-fab md-fab" ng-show="$ctrl.isLastStep()" aria-label="Hide" ng-click="$ctrl.hideTutorial()">
                            <md-icon md-svg-icon="navigation:ic_check_24px"></md-icon>
                        </md-button>
                    </div>

                    <div class="search-tutorial-dots" layout="row" layout-align="center center">
                        <span class="dot-wrapper" ng-repeat="step in $ctrl.steps"><div class="dot" ng-class="$ctrl.currentStep === step ? 'active': 'inactive'"></div></span>
                    </div>
                </div>
            </div>
        `
    });

})(angular);
